"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoginGenerator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _VpnKey = _interopRequireDefault(require("@material-ui/icons/VpnKey"));
var _generateStyle = _interopRequireDefault(require("./utils/generateStyle"));
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var LoginGenerator = function LoginGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var functions = uiConfig.functions;
  var useAuth = functions && typeof functions.useAuth === 'function' ? functions.useAuth : _config.default.functions.useAuth;
  var redirect = functions && typeof functions.redirect === 'function' ? functions.redirect : _config.default.functions.redirect;
  var useQuery = functions && typeof functions.useQuery === 'function' ? functions.useQuery : _config.default.functions.useQuery;
  var getRedirectPath = functions && typeof functions.getRedirectPath === 'function' ? functions.getRedirectPath : _config.default.functions.getRedirectPath;
  var getIdps = functions && typeof functions.getIdps === 'function' ? functions.getIdps : _config.default.functions.getIdps;

  // const stateProps = () => ({
  //   // autocomplete: state.login.autocomplete,
  // });

  // const dispatchProps = (dispatch) => ({
  //   signIn: (data) => dispatch(signInRed(data)),
  //   signOut: () => dispatch(signOutRed()),
  // });

  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    Login: function Login(props) {
      var styles = props.styles,
        authenticationProviders = props.authenticationProviders,
        onSuccess = props.onSuccess,
        onError = props.onError,
        AlertMessage = props.AlertMessage,
        enabledAuthProviders = props.enabledAuthProviders;
      /* styles */
      var generatedStyle = (0, _generateStyle.default)(styles);
      var useStyles = (0, _styles.makeStyles)(generatedStyle);
      var classes = useStyles();

      /* states */
      var _ref = (0, _react.useState)(''),
        _ref2 = _slicedToArray(_ref, 2),
        error = _ref2[0],
        setError = _ref2[1];
      /* hooks */
      var _useAuth = useAuth(),
        signInWithGoogle = _useAuth.signInWithGoogle,
        signInWithNIH = _useAuth.signInWithNIH;
      var history = (0, _reactRouterDom.useHistory)();
      var query = useQuery();

      /* variables */
      var internalRedirectPath = getRedirectPath(query);
      var idps = getIdps(enabledAuthProviders, authenticationProviders);

      /* event handlers */
      var onSuccessDefault = function onSuccessDefault() {
        return redirect(history, internalRedirectPath);
      };
      var onErrorDefault = function onErrorDefault() {};
      var onSuccessHandler = onSuccess || onSuccessDefault;
      var onErrorHandler = onError || onErrorDefault;
      var showAlert = function showAlert(alertType) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var key = Math.random();
        if (alertType === 'error') {
          setError( /*#__PURE__*/_react.default.createElement(AlertMessage, {
            key: key,
            severity: "error",
            borderColor: "#f44336",
            backgroundColor: "#f44336",
            timeout: 5000
          }, errorMsg));
        }
        if (alertType === 'redirect') {
          setError( /*#__PURE__*/_react.default.createElement(AlertMessage, {
            key: key,
            severity: "error",
            timeout: 5000
          }, "Please login to access protected data"));
        }
        return null;
      };
      var signInCall = function signInCall(provider) {
        if (provider) {
          switch (provider.key) {
            case 'google':
              signInWithGoogle(onSuccessHandler, onErrorHandler);
              break;
            case 'nih':
              signInWithNIH({
                internalRedirectPath: internalRedirectPath
              });
              break;
            case 'loginGov':
              signInWithNIH({
                internalRedirectPath: internalRedirectPath
              });
              break;
            default:
              showAlert('error', "The selected Identity Provider, ".concat(provider.key, ", is not currently supported. Please contact bento-help@nih.gov for more information."));
          }
        }
      };

      /* useEffect hooks */
      (0, _react.useEffect)(function () {
        if (internalRedirectPath !== '/') {
          showAlert('redirect');
        }
      }, []);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.Container
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        direction: "column",
        justifyContent: "flex-start",
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        justifyContent: "center",
        className: classes.emptySpace
      }, error), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        justifyContent: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        spacing: 1
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        sm: 4
      }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        sm: 4,
        justifyContent: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        xs: 12,
        alignItems: "center",
        justify: "center",
        direction: "column",
        className: classes.Box
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        justifyContent: "center",
        className: classes.LoginBoxTitle
      }, "Log in with either of these Identity providers:"), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        justifyContent: "center",
        className: classes.LoginButtonGroup
      }, Object.values(idps).map(function (provider) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 12,
          justifyContent: "center"
        }, /*#__PURE__*/_react.default.createElement(_core.Button, {
          variant: "outlined",
          className: [classes.LoginButton],
          disableRipple: true,
          onClick: function onClick() {
            return signInCall(provider);
          }
        }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 1,
          justifyContent: "center"
        }, provider.icon ? /*#__PURE__*/_react.default.createElement("img", {
          src: provider.icon,
          className: classes.root,
          alt: "alt coming"
        }) : /*#__PURE__*/_react.default.createElement(_VpnKey.default, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 11,
          justifyContent: "center"
        }, provider.loginButtonText)));
      })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        sm: 4
      })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        item: true,
        justifyContent: "center",
        className: [classes.emptySpace, classes.extraSpaceInBorrom]
      }));
    }
  };
};
exports.LoginGenerator = LoginGenerator;
var _default = LoginGenerator;
exports.default = _default;